import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import SeoHeader from "../seoHeader/SeoHeader";
import "./Header.css";

class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = { t: this.now() };
  }
  now() {
    try {
      return new Date().toLocaleTimeString("en-GB", {
        timeZone: "Africa/Casablanca",
        hour12: false,
      });
    } catch (e) {
      return new Date().toLocaleTimeString("en-GB", { hour12: false });
    }
  }
  componentDidMount() {
    this.timer = setInterval(() => this.setState({ t: this.now() }), 1000);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    return <b>{this.state.t}</b>;
  }
}

class Header extends Component {
  componentDidMount() {
    this.raf = null;
    this.onScroll = () => {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        const doc = document.documentElement;
        const max = doc.scrollHeight - doc.clientHeight;
        const p = max > 0 ? (doc.scrollTop / max) * 100 : 0;
        if (this.bar) this.bar.style.width = p + "%";
      });
    };
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.raf) cancelAnimationFrame(this.raf);
  }
  render() {
    return (
      <>
        <SeoHeader />
        <header className="topbar">
          <NavLink to="/" exact className="mark">
            <span className="sq"></span> WALIDMAANINOU.COM
          </NavLink>
          <nav className="nav">
            <NavLink to="/" exact activeClassName="active">INDEX</NavLink>
            <NavLink to="/projects" activeClassName="active">PROJECTS</NavLink>
            <NavLink to="/cv" activeClassName="active">CV</NavLink>
            <NavLink to="/experience" activeClassName="active">EXPERIENCE</NavLink>
            <NavLink to="/education" activeClassName="active">EDUCATION</NavLink>
            <NavLink to="/opensource" activeClassName="active">GITHUB</NavLink>
            <NavLink to="/contact" activeClassName="active">CONTACT</NavLink>
          </nav>
          <div className="meta">
            <span className="clk">CASA <Clock /></span>
            <span className="live">AVAILABLE</span>
          </div>
          <div className="progress" ref={(el) => (this.bar = el)} />
        </header>
      </>
    );
  }
}

export default Header;
